<template>
  <div class="ide-page">
    <!-- Header -->
    <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:20px; flex-wrap:wrap; gap:12px;">
      <div>
        <h2 style="font-size:18px; font-weight:800; color:var(--text-heading); margin-bottom:4px;">Pedidos</h2>
        <p style="font-size:12px; color:var(--text-faint);">Todos los pedidos del ecommerce y WhatsApp</p>
      </div>
      <div style="display:flex; gap:8px;">
        <button @click="filtroEstado = null" :style="filtroEstadoStyle(null)">Todos</button>
        <button @click="filtroEstado = 'pendiente_confirmacion'" :style="filtroEstadoStyle('pendiente_confirmacion')">Pendientes</button>
        <button @click="filtroEstado = 'confirmado'" :style="filtroEstadoStyle('confirmado')">Confirmados</button>
        <button @click="filtroEstado = 'entregado'" :style="filtroEstadoStyle('entregado')">Entregados</button>
      </div>
    </div>

    <!-- Stats -->
    <div style="display:grid; grid-template-columns:repeat(auto-fit, minmax(140px, 1fr)); gap:10px; margin-bottom:20px;">
      <div class="ide-ia-card" style="padding:12px 14px; text-align:center;">
        <div style="font-size:20px; font-weight:900; color:var(--text-heading);">{{ totalPedidos }}</div>
        <div style="font-size:10px; color:var(--text-faint); margin-top:3px;">Total pedidos</div>
      </div>
      <div class="ide-ia-card" style="padding:12px 14px; text-align:center;">
        <div style="font-size:20px; font-weight:900; color:#f59e0b;">{{ pendientes }}</div>
        <div style="font-size:10px; color:var(--text-faint); margin-top:3px;">Pendientes</div>
      </div>
      <div class="ide-ia-card" style="padding:12px 14px; text-align:center;">
        <div style="font-size:20px; font-weight:900; color:#22c55e;">{{ entregados }}</div>
        <div style="font-size:10px; color:var(--text-faint); margin-top:3px;">Entregados</div>
      </div>
      <div class="ide-ia-card" style="padding:12px 14px; text-align:center;">
        <div style="font-size:20px; font-weight:900; color:var(--text-heading);">${{ totalVentas.toFixed(2) }}</div>
        <div style="font-size:10px; color:var(--text-faint); margin-top:3px;">Ventas totales</div>
      </div>
    </div>

    <!-- Tabla de pedidos -->
    <div class="ide-ia-card" style="overflow-x:auto; padding:0;">
      <table style="width:100%; border-collapse:collapse; font-size:12px;">
        <thead style="background:var(--bg-alt); border-bottom:1px solid var(--border);">
          <tr>
            <th style="padding:10px 12px; text-align:left; font-weight:600;">Código</th>
            <th style="padding:10px 12px; text-align:left; font-weight:600;">Cliente</th>
            <th style="padding:10px 12px; text-align:left; font-weight:600;">Sucursal</th>
            <th style="padding:10px 12px; text-align:center; font-weight:600;">Items</th>
            <th style="padding:10px 12px; text-align:right; font-weight:600;">Total</th>
            <th style="padding:10px 12px; text-align:center; font-weight:600;">Estado</th>
            <th style="padding:10px 12px; text-align:center; font-weight:600;">Pago</th>
            <th style="padding:10px 12px; text-align:center; font-weight:600;">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!pedidosFiltrados.length" style="border-bottom:1px solid var(--border);">
            <td colspan="8" style="padding:24px; text-align:center; color:var(--text-disabled);">Sin pedidos</td>
          </tr>
          <tr v-for="p in pedidosFiltrados" :key="p.id" style="border-bottom:1px solid var(--border-card); cursor:pointer;" @click="abrirDetalle(p)">
            <td style="padding:10px 12px; font-weight:600; color:#818cf8;">{{ p.codigoPedido }}</td>
            <td style="padding:10px 12px;">
              <div style="font-weight:600;">{{ p.nombreCliente || 'Anónimo' }}</div>
              <div style="font-size:10px; color:var(--text-faint);">{{ p.telefonoCliente }}</div>
            </td>
            <td style="padding:10px 12px; font-size:11px;">{{ p.sucursalNombre || '—' }}</td>
            <td style="padding:10px 12px; text-align:center;">{{ (p.items || []).length }}</td>
            <td style="padding:10px 12px; text-align:right; font-weight:600;">${{ Number(p.total).toFixed(2) }}</td>
            <td style="padding:10px 12px; text-align:center;">
              <span :style="{ background: estadoColor(p.estadoPedido), color: 'white', padding: '3px 8px', borderRadius: '4px', fontSize: '10px', fontWeight: '600' }">
                {{ estadoLabel(p.estadoPedido) }}
              </span>
            </td>
            <td style="padding:10px 12px; text-align:center;">
              <span :style="{ background: pagoColor(p.estadoPago), color: 'white', padding: '3px 8px', borderRadius: '4px', fontSize: '10px', fontWeight: '600' }">
                {{ pagoLabel(p.estadoPago) }}
              </span>
            </td>
            <td style="padding:10px 12px; text-align:center;">
              <button @click.stop="abrirDetalle(p)" style="background:none; border:none; cursor:pointer; color:#818cf8; font-size:12px;">Ver →</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal: Detalle de pedido -->
    <div v-if="dialogDetalle" class="cat-overlay" @click.self="dialogDetalle = false">
      <div class="cat-modal" style="max-width:600px;">
        <div style="display:flex; align-items:center; justify-content:space-between; padding:18px 22px 14px; border-bottom:1px solid var(--border);">
          <span style="font-size:15px; font-weight:700; color:var(--text-heading);">{{ pedidoSeleccionado?.codigoPedido }}</span>
          <button @click="dialogDetalle = false" style="background:none; border:none; cursor:pointer; color:var(--text-disabled); padding:4px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        <div style="overflow-y:auto; padding:18px 22px; max-height:60vh;">
          <!-- Info cliente -->
          <div style="margin-bottom:16px; padding-bottom:16px; border-bottom:1px solid var(--border);">
            <div style="font-size:11px; color:var(--text-faint); margin-bottom:6px;">CLIENTE</div>
            <div style="font-weight:600; color:var(--text-heading);">{{ pedidoSeleccionado?.nombreCliente || 'Anónimo' }}</div>
            <div style="font-size:11px; color:var(--text-muted);">{{ pedidoSeleccionado?.telefonoCliente }}</div>
          </div>

          <!-- Sucursal -->
          <div style="margin-bottom:16px; padding-bottom:16px; border-bottom:1px solid var(--border);">
            <div style="font-size:11px; color:var(--text-faint); margin-bottom:6px;">SUCURSAL</div>
            <div style="font-weight:600; color:var(--text-heading);">{{ pedidoSeleccionado?.sucursalNombre }}</div>
            <div style="font-size:11px; color:var(--text-muted);">{{ pedidoSeleccionado?.sucursalDireccion }}</div>
          </div>

          <!-- Items -->
          <div style="margin-bottom:16px; padding-bottom:16px; border-bottom:1px solid var(--border);">
            <div style="font-size:11px; color:var(--text-faint); margin-bottom:8px;">ITEMS</div>
            <div v-for="(item, i) in pedidoSeleccionado?.items || []" :key="i" style="display:flex; justify-content:space-between; margin-bottom:6px; font-size:12px;">
              <span>{{ item.nombre }} x{{ item.cantidad }}</span>
              <span style="font-weight:600;">${{ (item.subtotal || 0).toFixed(2) }}</span>
            </div>
          </div>

          <!-- Totales -->
          <div style="margin-bottom:16px; padding:12px; background:var(--bg-alt); border-radius:6px;">
            <div style="display:flex; justify-content:space-between; font-size:12px; margin-bottom:4px;">
              <span>Subtotal:</span>
              <span>${{ (pedidoSeleccionado?.subtotal || 0).toFixed(2) }}</span>
            </div>
            <div v-if="pedidoSeleccionado?.descuento" style="display:flex; justify-content:space-between; font-size:12px; margin-bottom:4px;">
              <span>Descuento:</span>
              <span style="color:#22c55e;">-${{ (pedidoSeleccionado?.descuento || 0).toFixed(2) }}</span>
            </div>
            <div style="display:flex; justify-content:space-between; font-size:13px; font-weight:700; border-top:1px solid var(--border); padding-top:6px;">
              <span>Total:</span>
              <span>${{ (pedidoSeleccionado?.total || 0).toFixed(2) }}</span>
            </div>
          </div>

          <!-- Estados -->
          <div style="display:grid; grid-template-columns:1fr 1fr; gap:12px;">
            <div>
              <div style="font-size:11px; color:var(--text-faint); margin-bottom:4px;">ESTADO PEDIDO</div>
              <span :style="{ background: estadoColor(pedidoSeleccionado?.estadoPedido), color: 'white', padding: '4px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: '600' }">
                {{ estadoLabel(pedidoSeleccionado?.estadoPedido) }}
              </span>
            </div>
            <div>
              <div style="font-size:11px; color:var(--text-faint); margin-bottom:4px;">ESTADO PAGO</div>
              <span :style="{ background: pagoColor(pedidoSeleccionado?.estadoPago), color: 'white', padding: '4px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: '600' }">
                {{ pagoLabel(pedidoSeleccionado?.estadoPago) }}
              </span>
            </div>
          </div>
        </div>

        <div style="display:flex; gap:8px; padding:16px 22px; border-top:1px solid var(--border);">
          <button @click="dialogDetalle = false" style="flex:1; background:none; border:1px solid var(--border); border-radius:6px; padding:8px; cursor:pointer; color:var(--text-muted); font-family:inherit;">
            Cerrar
          </button>
          <button v-if="puedeCambiarEstado" @click="abrirCambioEstado" style="flex:1; background:#818cf8; color:white; border:none; border-radius:6px; padding:8px; cursor:pointer; font-family:inherit; font-weight:600;">
            Cambiar estado
          </button>
        </div>
      </div>
    </div>

    <!-- Modal: Cambiar estado -->
    <div v-if="dialogCambioEstado" class="cat-overlay" @click.self="dialogCambioEstado = false">
      <div class="cat-modal" style="max-width:350px;">
        <div style="display:flex; align-items:center; justify-content:space-between; padding:18px 22px 14px; border-bottom:1px solid var(--border);">
          <span style="font-size:15px; font-weight:700; color:var(--text-heading);">Cambiar estado</span>
          <button @click="dialogCambioEstado = false" style="background:none; border:none; cursor:pointer; color:var(--text-disabled); padding:4px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <div style="padding:18px 22px;">
          <div style="font-size:12px; color:var(--text-faint); margin-bottom:12px;">Estado actual: <strong>{{ estadoLabel(pedidoSeleccionado?.estadoPedido) }}</strong></div>
          <div style="display:flex; flex-direction:column; gap:8px;">
            <button v-for="sig in estadosSiguientes" :key="sig" @click="cambiarEstado(sig)" style="background:#818cf8; color:white; border:none; border-radius:6px; padding:10px; cursor:pointer; font-family:inherit; font-size:12px; font-weight:600; transition:0.2s;" @mouseover="$event.target.style.background='#6366f1'" @mouseout="$event.target.style.background='#818cf8'">
              → {{ estadoLabel(sig) }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pedidos',
  data() {
    return {
      pedidos: [],
      filtroEstado: null,
      dialogDetalle: false,
      dialogCambioEstado: false,
      pedidoSeleccionado: null,
      loading: false,
    }
  },
  computed: {
    clienteId() {
      return this.$store.getters.clienteId
    },
    pedidosFiltrados() {
      if (!this.filtroEstado) return this.pedidos
      return this.pedidos.filter(p => p.estadoPedido === this.filtroEstado)
    },
    totalPedidos() {
      return this.pedidos.length
    },
    pendientes() {
      return this.pedidos.filter(p => p.estadoPedido === 'pendiente_confirmacion').length
    },
    entregados() {
      return this.pedidos.filter(p => p.estadoPedido === 'entregado').length
    },
    totalVentas() {
      return this.pedidos.reduce((sum, p) => sum + (Number(p.total) || 0), 0)
    },
    puedeCambiarEstado() {
      return this.pedidoSeleccionado && !['entregado', 'cancelado'].includes(this.pedidoSeleccionado.estadoPedido)
    },
    estadosSiguientes() {
      const map = {
        'pendiente_confirmacion': ['confirmado', 'cancelado'],
        'confirmado': ['en_preparacion', 'cancelado'],
        'en_preparacion': ['listo', 'cancelado'],
        'listo': ['en_camino', 'cancelado'],
        'en_camino': ['entregado', 'cancelado'],
      }
      return map[this.pedidoSeleccionado?.estadoPedido] || []
    },
  },
  mounted() {
    this.cargar()
    this.intervalo = setInterval(() => this.cargar(), 30000)
  },
  beforeDestroy() {
    if (this.intervalo) clearInterval(this.intervalo)
  },
  methods: {
    async cargar() {
      if (!this.clienteId) return
      this.loading = true
      try {
        // Cargar de todas las sucursales del cliente
        const sucursales = await this.$service.list('sucursales') || []
        const allPedidos = []
        for (const sucursal of sucursales) {
          const pedidos = await this.$service.list(`sucursales/${sucursal.id}/pedidos`) || []
          allPedidos.push(...pedidos.map(p => ({ ...p, sucursalNombre: sucursal.nombre, sucursalDireccion: sucursal.direccion })))
        }
        this.pedidos = allPedidos.sort((a, b) => new Date(b._fecha_creacion || 0) - new Date(a._fecha_creacion || 0))
      } catch (err) {
        this.$message.error('Error al cargar pedidos')
      } finally {
        this.loading = false
      }
    },
    abrirDetalle(pedido) {
      this.pedidoSeleccionado = pedido
      this.dialogDetalle = true
    },
    abrirCambioEstado() {
      this.dialogCambioEstado = true
    },
    async cambiarEstado(nuevoEstado) {
      if (!this.pedidoSeleccionado) return
      try {
        await this.$service.patch(`pedidos/${this.pedidoSeleccionado.id}/estado`, { estadoPedido: nuevoEstado })
        this.$message.success(`Pedido actualizado a ${this.estadoLabel(nuevoEstado)}`)
        this.dialogCambioEstado = false
        this.cargar()
      } catch (err) {
        this.$message.error('Error al cambiar estado')
      }
    },
    estadoColor(estado) {
      const colores = {
        'pendiente_confirmacion': '#f59e0b',
        'confirmado': '#818cf8',
        'en_preparacion': '#0ea5e9',
        'listo': '#22c55e',
        'en_camino': '#8b5cf6',
        'entregado': '#6366f1',
        'cancelado': '#64748b',
      }
      return colores[estado] || '#64748b'
    },
    estadoLabel(estado) {
      const labels = {
        'pendiente_confirmacion': 'Pendiente',
        'confirmado': 'Confirmado',
        'en_preparacion': 'En prep.',
        'listo': 'Listo',
        'en_camino': 'En camino',
        'entregado': 'Entregado',
        'cancelado': 'Cancelado',
      }
      return labels[estado] || estado
    },
    pagoColor(estado) {
      const colores = { pendiente: '#f59e0b', pagado: '#22c55e', parcial: '#818cf8', anulado: '#64748b' }
      return colores[estado] || '#64748b'
    },
    pagoLabel(estado) {
      const labels = { pendiente: 'Pendiente', pagado: 'Pagado', parcial: 'Parcial', anulado: 'Anulado' }
      return labels[estado] || estado
    },
    filtroEstadoStyle(estado) {
      const activo = this.filtroEstado === estado
      return {
        background: activo ? '#818cf8' : 'transparent',
        color: activo ? 'white' : 'var(--text-muted)',
        border: `1px solid ${activo ? '#818cf8' : 'var(--border)'}`,
        borderRadius: '6px',
        padding: '6px 12px',
        fontSize: '12px',
        cursor: 'pointer',
        fontFamily: 'inherit',
        fontWeight: activo ? '600' : '400',
        transition: '0.2s',
      }
    },
  },
}
</script>
